import React from 'react';
import styles from './DesignersListingOverview.module.scss';

import {
  LayoutCardList,
  LayoutCardSize,
  LayoutCardListHeading,
  LayoutCardType,
} from 'src/modules/layout';
import { DesignerEntity } from 'src/modules/designers';

interface DesignersListingOverviewProps {
  relatedOverview?: boolean;
  designers: DesignerEntity[];
}

const DesignersListingOverview: React.FunctionComponent<DesignersListingOverviewProps> = (
  props
) => {
  const { designers, relatedOverview = false } = props;

  return designers.length ? (
    <div>
      {relatedOverview && (
        <div className={styles.heading}>
          <LayoutCardListHeading
            title="page/designers/details/section_designers_subheading"
            link="/designers"
            seeAll="page/designers/details/section_designers_more"
          />
        </div>
      )}

      <LayoutCardList
        // className={styles.designers}
        type={LayoutCardType.Overview}
        size={LayoutCardSize.Small}
        wrap={relatedOverview ? false : true}
        truncateTitle={true}
        items={designers.map((designer) => ({
          id: designer.id,
          image: designer.assets.length ? designer.assets[0].format_3x2 : { url: '' },
          slug: designer.slug,
          link: 'designers',
          // description: designer.description,
          title: designer.name,
        }))}
      />
    </div>
  ) : null;
};

export default DesignersListingOverview;
